module.exports = __webpack_public_path__ + "img/AL281-1-EN.4f2fa3ac.jpg";